import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import App from './App';

const theme = createTheme({
  palette: {
    primary: {
      main: '#0350AC',
      light: '#0365DD',
      dark: '#023C83',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#2B2E35',
    },
    error: {
      main: '#B3261E',
    },
    background: {
      default: '#F5F6F9',
      paper: '#ffffff',
    },
    text: {
      primary: '#2B2E35',
      secondary: '#6C717C',
    },
    divider: '#E3E5EA',
  },
  shape: {
    borderRadius: 12,
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);
